import { CodeBlock, useToast } from "@validereinc/common-components";
import { copyTextToClipboard } from "@validereinc/utilities";
import classNames from "classnames/bind";
import React, { useCallback, useMemo } from "react";
import styles from "./FormattedJsonDisplay.module.scss";

const cx = classNames.bind(styles);

export type FormattedJsonDisplayProps = {
  label?: string;
  data: unknown;
  className?: string;
  isFullWidth?: boolean;
  copySuccessMessage?: string;
};

export const FormattedJsonDisplay = ({
  label,
  data,
  className,
  isFullWidth = false,
  copySuccessMessage = "Copied to your clipboard.",
}: FormattedJsonDisplayProps) => {
  const { toast } = useToast();
  const formattedJson = useMemo(() => JSON.stringify(data, null, 2), [data]);

  const handleCopy = useCallback(() => {
    void copyTextToClipboard(formattedJson).then(() =>
      toast.push({
        intent: "success",
        description: copySuccessMessage,
      })
    );
  }, [copySuccessMessage, formattedJson, toast]);

  return (
    <div
      className={cx("formatted-json-display", className, {
        "formatted-json-display--full-width": isFullWidth,
      })}
    >
      {label ? (
        <p className={cx("formatted-json-display__label")}>{label}</p>
      ) : null}
      <CodeBlock
        className={cx("formatted-json-display__code-block", {
          "formatted-json-display__code-block--full-width": isFullWidth,
        })}
        onCopy={handleCopy}
      >
        {formattedJson}
      </CodeBlock>
    </div>
  );
};
